module.exports = __webpack_public_path__ + "media/images/default/banner_B-1986a3d966975d400d3a7735acdf991c.png";